"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilesWithSupportInfo = exports.getIsSelectedSingleFileFetched = exports.getSelectedSingleFile = exports.getUploadingFilesWithSupportInfo = void 0;

var _reselect = require("reselect");

var _Files = require("FileManagerCore/selectors/Files");

var _FileDetails = require("FileManagerCore/selectors/FileDetails");

var _fileFiltering = require("../utils/fileFiltering");

var _Filter = require("./Filter");

var _Panel = require("./Panel");

var _Configuration = require("./Configuration");

var getUploadingFiles = function getUploadingFiles(state) {
  return state.uploadingFiles.get('files').toList();
};

var getSelectedFolder = function getSelectedFolder(state) {
  return state.panel.getIn(['present', 'selectedFolder']);
};

var filterUploadingFiles = function filterUploadingFiles(uploadingFiles, selectedFolder) {
  if (selectedFolder) {
    var selectedFolderId = selectedFolder.get('id');
    return uploadingFiles.filter(function (file) {
      return file.get('folder_id') === selectedFolderId;
    });
  }

  return uploadingFiles;
};

var replaceFileInList = function replaceFileInList(files, fileToReplace) {
  var index = files.findIndex(function (f) {
    return f.get('id') === fileToReplace.get('id');
  });

  if (index >= 0) {
    var full_path = files.get(index).get('full_path');
    files = files.set(index, fileToReplace.merge({
      full_path: full_path
    }));
  }

  return files;
};

var getFilteredUploadingFiles = (0, _reselect.createSelector)([getUploadingFiles, getSelectedFolder], filterUploadingFiles);
var getUploadingFilesWithSupportInfo = (0, _reselect.createSelector)([getFilteredUploadingFiles, _Filter.getFilter, _Configuration.getIsHostAppContextPrivate], _fileFiltering.addSupportInfoToFiles);
exports.getUploadingFilesWithSupportInfo = getUploadingFilesWithSupportInfo;
var getSelectedSingleFile = (0, _reselect.createSelector)([_Panel.getSelectedFileId, _FileDetails.getSingleFileDetails], function (selectedFileId, singleFileDetails) {
  return selectedFileId ? singleFileDetails.get(selectedFileId) : null;
});
exports.getSelectedSingleFile = getSelectedSingleFile;
var getIsSelectedSingleFileFetched = (0, _reselect.createSelector)([getSelectedSingleFile], function (selectedFile) {
  return Boolean(selectedFile);
});
exports.getIsSelectedSingleFileFetched = getIsSelectedSingleFileFetched;
var getFilesWithSupportInfo = (0, _reselect.createSelector)([_Files.getFiles, _Filter.getFilter, getSelectedSingleFile, _Configuration.getIsHostAppContextPrivate], function (files, filter, selectedSingleFile, isHostAppContextPrivate) {
  if (selectedSingleFile) {
    files = replaceFileInList(files, selectedSingleFile);
  }

  return (0, _fileFiltering.addSupportInfoToFiles)(files, filter, isHostAppContextPrivate);
});
exports.getFilesWithSupportInfo = getFilesWithSupportInfo;